import BigButton from "./BigButton";
import { primary45 } from "../../utils/color"
import { useState } from "react";

//PC_FG_09
export default function PagingControl({ totalPages, pageNum, setPageNum, policyname ,view, isChecked}) {
  //PC_FG_03 creating styles
  const styles = {
    container: {
      marginTop: 8,
      marginBottom: 8,
    },
    inlineFlex: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'

    },
    pageInfo: {
      padding: 8,
      color: "white",
      fontSize: 14,

    }
  }
  return (
    //PC_FG_04
    <div style={styles.container}>
      
      {/* //PC_FG_05 */}
      <div style={styles.inlineFlex}>
      { view == false ?
        (<div class="d-flex align-items-center gap-2 me-5" style={{marginLeft: "-350px" }}>
          <input type="checkbox" id="agreement" onChange={(event) => {isChecked(event.target.checked)}} 
          class="form-check-input policy-check mt-0" />
          <label class="font-12 semibold-text" for="agreement" style={{color:"white",fontFamily:"SF Pro Bold",fontSize:"20px"}}>I have read and agree to AVASOFT - {policyname}.</label>
        </div>):<></>
        }
      <button
        style={{
          marginLeft:"210px",
          backgroundColor: '#FFEED2',
          color: '#F29B10',
          border: 'none',
          borderRadius: '4px',
          padding: '2px 10px',
          cursor: 'pointer',
          fontSize: '16px',
          transition: 'background-color 0.3s ease',
          
        }}
          title={"<"}
          // PC_FG_06 to minus one page to show previous page
          onClick={() => setPageNum(pageNum - 1)}
          disabled={pageNum - 1 === -1}
        >&lt;</button>
        {/* //PC_FG_07 To show the total number of pages */}
        <div style={styles.pageInfo} className="tt-bold font-15 pt-3 mb-1">
          Page: {pageNum + 1}/{totalPages}
        </div>
        <button 
        style={{
          backgroundColor: '#FFEED2',
          color: '#F29B10',
          border: 'none',
          borderRadius: '4px',
          padding: '2px 10px',
          cursor: 'pointer',
          fontSize: '16px',
          transition: 'background-color 0.3s ease'
        }}
          title={">"}
          // PC_FG_08 to add a page shown the next page
          onClick={() => setPageNum(pageNum + 1)}
          disabled={pageNum + 1 > totalPages - 1}
        >&gt;</button> 
        </div>
       

    </div>
  );
}